import React from 'react';
import './About.css';
import missionImage from '../mission-image.jpeg';
import schoolIcon from '../school.png';
import eyeIcon from '../eye.png';
import targetIcon from '../target.png';

const About = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="about-header">
          <div className="about-line"></div>
          <h2 className="about-title">About Gurukulam</h2>
        </div>
        
        <div className="about-content">
          <div className="about-image">
            <img src={missionImage} alt="About Gurukulam" />
          </div>
          
          <div className="about-text">
            <div className="about-description">
              <p>
                Sri Veda Gurukulam is a traditional center of Vedic learning dedicated to 
                preserving and propagating India's ancient spiritual heritage through the 
                Gurukul system. Guided by experienced Acharyas, students live and 
                learn in a disciplined, value-based environment rooted in the teacher-
                disciple tradition. The Gurukulam imparts comprehensive education in 
                Vedas, Sanskrit, rituals, and Indian philosophy, combined with daily 
                spiritual practices and character development. Strong emphasis is placed 
                on character building, self-discipline, humility, and 
                service. Sri Veda Gurukulam nurtures spiritually aware individuals who 
                uphold Dharma and contribute meaningfully to society while carrying 
                forward timeless Vedic wisdom.
              </p>
            </div>
            
            <div className="vision-mission">
              <div className="vision">
                <h3>
                  <img src={eyeIcon} alt="Vision" className="vm-icon-img" />
                  Vision
                </h3>
                <p>To preserve, practice, and propagate Vedic knowledge for future generations.</p>
              </div>
              
              <div className="mission">
                <h3>
                  <img src={targetIcon} alt="Mission" className="vm-icon-img" />
                  Mission
                </h3>
                <p>To provide authentic Vedic education through disciplined gurukul life, guided by learned Acharyas, fostering spiritual, ethical, and cultural excellence.</p>
              </div>
            </div>
            
            <div className="about-button">
              <button className="explore-btn">
                <img src={schoolIcon} alt="School" className="btn-icon" />
                Explore Our Gurukul
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;